import styled from 'styled-components'
import { COLOR, FONT_SIZE } from '../../themes'

export const TOAST = styled.div`
  height: 65px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 0 15px;
  font-size: ${FONT_SIZE.TN};
  font-weight: 600;
  position: fixed;
  z-index: 999999;
  bottom: 27px;
  right: 33px;
  transition: transform 0.5s ease-in-out;
  animation: toast-in-right 0.5s;

  .icon {
    padding-top: 4px;
    width: 20px;
    height: 20px;
  }

  .divider {
    margin: 0 20px 0 0;
    height: 32px;
    width: 1px;
    background: ${COLOR.WHITE};
  }

  .message {
    white-space: pre-wrap;
    width: 250px;
    color: ${COLOR.WHITE};
    line-height: 150%;
  }

  .action-text {
    cursor: pointer;
    margin: 0 20px 0 0;
    color: ${COLOR.GOLD_1};
  }

  .close-btn {
    cursor: pointer;
  }

  @keyframes toast-in-right {
	from {
	  transform: translateX(100%);
	  
	}
	to {
	  transform: translateX(0);
	}
}
`
